// import { AntDesignOutlined } from "@ant-design/icons";
import { notification } from 'antd'
import axios from 'axios'

// const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  getDevices: '/catalog/device',
  opDevice: '/catalog/device',
}

// get Devices
export async function getDevices(token) {
  const auth = `Bearer ${token}`
  // console.log('auth:', auth)
  const url = fsConfig.root + fsConfig.getDevices
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: auth,
    },
  }

  return axios
    .get(url, newConfig)
    .then(response => {
      const result = response.data.map((el, ndx) => {
        const o = Object.assign({}, el)
        o.key = `${ndx + 1}`

        // el usuario lo hago objeto
        o.project = JSON.parse(o.project)
        o.site = JSON.parse(o.site)

        return o
      })
      response.data = result
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error obteniendo dispositivos',
        description: error.message,
      })
    })
}

// add new device
export async function postDevice(token, device) {
  const url = fsConfig.root + fsConfig.opDevice
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }

  // borra los campos auxiliares que no se graban
  delete device.projectMaster
  delete device.siteMater

  return axios
    .post(url, device, newConfig)
    .then(response => {
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error agregando dispositivo',
        description: error.message,
      })
    })
}

export async function putDevice(token, device) {
  const url = fsConfig.root + fsConfig.opDevice
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  const { key } = device
  delete device.key
  delete device.projectMaster
  delete device.siteMaster
  delete device.project
  delete device.site

  return axios
    .put(url, device, newConfig)
    .then(response => {
      response.key = key
      return response
    })
    .catch(error => {
      console.log('Error:', error)
      notification.warning({
        message: 'Error grabando dispositivo',
        description: error.message,
      })
    })
}

export async function deleteDevice(token, deviceUid) {
  const url = `${fsConfig.root}${fsConfig.opDevice}/${deviceUid}`
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .delete(url, newConfig)
    .then(response => {
      const { result } = response.data
      return result
    })
    .catch(error => {
      notification.warning({
        message: 'Error eliminando dispositivo',
        description: error.message,
      })
    })
}
